import { render, staticRenderFns } from "./PasskeyStepUpPage.vue?vue&type=template&id=1f0ea66e&scoped=true"
import script from "./PasskeyStepUpPage.vue?vue&type=script&lang=ts"
export * from "./PasskeyStepUpPage.vue?vue&type=script&lang=ts"
import style0 from "./PasskeyStepUpPage.vue?vue&type=style&index=0&id=1f0ea66e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0ea66e",
  null
  
)

export default component.exports